export default "__VITE_ASSET__D402iKmm__"